import styled from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

interface WrapperProps {
  isVisible: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  position: sticky;
  bottom: 0;
  z-index: 10;

  grid-column: 1 / -1;

  margin-top: ${({ isVisible }) => (isVisible ? '0' : '100dvh')};

  transition: margin-top 0.3s ease;

  ${mediaDesktop(`
    display: none;
  `)}
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px;

  background-color: ${colors.white};
`;

export const Avatar = styled.img`
  width: 86px;
  height: 86px;
  object-fit: cover;

  margin-right: 16px;
`;

export const Bio = styled.p`
  ${({ theme: { locale } }) => setTypography('smallBody', locale)}
  margin-top: 8px;
  color: ${colors.dustyGray};
`;
